import React, { useState } from 'react';
import { getSystemLogo } from '../../services';

type Props = {
    url: string;
    alt: string;
    hiddenSystemLogo?: boolean;
}

const ImageHandler: React.FC<Props> = ({ url, alt, hiddenSystemLogo = false }) => {
    const [isSystemLogo, setIsSystemLogo] = useState<boolean>(false);

    if (isSystemLogo && hiddenSystemLogo)
        return <div />;

    return (
        <img
            src={isSystemLogo ? getSystemLogo() : url}
            alt={alt}
            onError={() => setIsSystemLogo(true)}
        />
    );
};

export { ImageHandler };
